import React, { Fragment } from "react";

const ContactSection = () => {
  return (
    <Fragment>
      <section className="bg-gradient-to-r from-green-500 via-green-600 to-green-700 scroll-section">
        <div className="overflow-hidden">
          <div className="container px-8 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
            <div className="flex flex-col items-center justify-between xl:flex-row">
              <div className="w-full max-w-xl xl:px-8 xl:w-4/5">
                <div className="relative">
                  <svg
                    viewBox="0 0 52 24"
                    fill="currentColor"
                    className="absolute bottom-0 right-0 z-0 hidden w-32 -mb-8 -mr-20 text-amber-400 lg:w-32 lg:-mr-16 sm:block"
                  >
                    <defs>
                      <pattern
                        id="766323e1-e594-4ffd-a688-e7275079d540"
                        x="0"
                        y="0"
                        width=".135"
                        height=".30"
                      >
                        <circle cx="1" cy="1" r=".7"></circle>
                      </pattern>
                    </defs>
                    <rect
                      fill="url(#766323e1-e594-4ffd-a688-e7275079d540)"
                      width="52"
                      height="24"
                    ></rect>
                  </svg>
                  <div
                    id="getQuote"
                    className="relative bg-gray-100 rounded-xl shadow-2xl p-7 sm:p-10"
                  >
                    <h3 className="mb-1 text-xl text-gray-800 font-semibold text-center sm:text-center sm:text-2xl custom-font-2 tracking-wide">
                      Start Your Solar Journey Here
                    </h3>
                    <p className="mb-3 sm:mb-6 text-xs font-semibold tracking-wider uppercase text-center sm:text-center">
                      <span className="transition-colors duration-200 text-gray-800">
                        See all the benefits and savings of going solar.
                      </span>
                    </p>
                    <form id="frmGetQuote">
                      <div className="mb-1 sm:mb-2">
                        <label
                          htmlFor="name"
                          className="inline-block mb-1 font-medium text-md sm:text-lg text-gray-600 tracking-wide"
                        >
                          Contact Information
                        </label>
                        <input
                          placeholder="Full name"
                          required=""
                          type="text"
                          className="flex-grow w-full h-12 px-4 mb-2 mt-2 transition duration-200 bg-gray-50 border border-gray-200 rounded-md shadow-sm appearance-none focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 focus:outline-none tracking-wider font-normal text-md sm:text-lg custom-font-2 placeholder-gray-400"
                          id="name"
                          name="name"
                        />
                      </div>
                      <div className="mb-1 sm:mb-2">
                        <input
                          placeholder="Email address"
                          required=""
                          type="email"
                          className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-gray-50 border border-gray-200 rounded-md shadow-sm appearance-none focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 focus:outline-none tracking-wider font-normal text-md sm:text-lg custom-font-2 placeholder-gray-400"
                          id="receiver"
                          name="email"
                        />
                      </div>
                      <div className="mb-1 sm:mb-2">
                        <input
                          placeholder="Phone number"
                          required=""
                          type="tel"
                          className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-gray-50 border border-gray-200 rounded-md shadow-sm appearance-none focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 focus:outline-none tracking-wider font-normal text-md sm:text-lg custom-font-2 placeholder-gray-400"
                          id="phonenumber"
                          name="phonenumber"
                        />
                      </div>
                      <div className="mb-1 sm:mb-2">
                        <label
                          htmlFor="subject"
                          className="inline-block mb-1 font-medium text-md sm:text-lg text-gray-600 tracking-wide"
                        >
                          Subject
                        </label>
                        <select
                          className="block w-full text-md sm:text-lg px-5 py-3 mt-2 transition duration-200 text-gray-700 bg-gray-50 border border-gray-200 rounded-md focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 focus:outline-none tracking-wider font-normal custom-font-2"
                          id="subject"
                        >
                          <option
                            className="tracking-wide font-normal"
                            value="General Inquiry"
                          >
                            General Inquiry
                          </option>
                          <option
                            className="tracking-wide font-normal"
                            value="Quote Request"
                          >
                            Quote Request
                          </option>
                          <option
                            className="tracking-wide font-normal"
                            value="Installation Services"
                          >
                            Installation Services
                          </option>
                          <option
                            className="tracking-wide font-normal"
                            value="Project Consultation"
                          >
                            Project Consultation
                          </option>
                          <option
                            className="tracking-wide font-normal"
                            value="Solar PV Training Program"
                          >
                            Solar PV Training Program
                          </option>
                          <option
                            className="tracking-wide font-normal"
                            value="Partnership Opportunities"
                          >
                            Partnership Opportunities
                          </option>
                        </select>
                      </div>
                      <div className="mb-1 sm:mb-2">
                        <label
                          htmlFor="message"
                          className="inline-block mb-1 font-medium text-md sm:text-lg text-gray-600 tracking-wide"
                        >
                          Message
                        </label>
                        <textarea
                          className="block w-full text-md sm:text-lg h-20 md:h-32 px-5 py-3 mt-2 text-gray-700 placeholder-gray-400 bg-gray-50 border border-gray-200 rounded-md focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 focus:outline-none transition duration-200 tracking-wider font-normal custom-font-2"
                          placeholder="How can we help you?"
                          id="text"
                        ></textarea>
                      </div>
                      <div className="mt-2 mb-2 sm:mb-4">
                        <button
                          type="submit"
                          className="focus:shadow-outline focus:outline-none w-full py-3 mt-6 text-lg transform focus:ring focus:ring-blue-400 focus:ring-opacity-50 inline-flex items-center justify-center h-12 px-6 font-medium tracking-widest text-white transition duration-200 rounded shadow-md bg-green-500 hover:opacity-75 focus:shadow-outline custom-font-2 capitalize"
                          disabled
                        >
                          Send a message
                        </button>
                      </div>
                      <p className="text-xs text-gray-600 sm:text-sm custom-font-2 tracking-normal">
                        By clicking the '<strong>Send A Message</strong>'
                        button, you agree to share your personal information
                        with us.
                      </p>
                    </form>
                  </div>
                </div>
              </div>
              {/* Divider */}
              <div className="w-full max-w-xl mb-12 xl:pr-16 xl:mb-0 xl:w-7/12 custom-font-2">
                <p className="flex items-start mb-4 -mx-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 sm:w-6 sm:h-6 mt-0 sm:mt-0.5 mx-2 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>

                  <span className="mx-2 font-semibold text-sm sm:text-lg tracking-wide text-gray-50 truncate w-auto">
                    <a
                      href="https://goo.gl/maps/4mEtz6eKJZZZQ3GKA"
                      className="transition-colors duration-300 transform hover:opacity-75 md:hover:underline underline md:no-underline underline-offset-4"
                    >
                      279 Malagasang Road 1C, Imus, Cavite
                    </a>
                  </span>
                </p>

                <p className="flex items-start mb-4 -mx-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 sm:w-6 sm:h-6 mt-0 sm:mt-0.5 mx-2 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>

                  <span className="mx-2 font-semibold text-sm sm:text-lg tracking-wide text-gray-50 truncate w-auto">
                    <a
                      href="https://goo.gl/maps/AHpVHAHrv7et3v476"
                      className="transition-colors duration-300 transform hover:opacity-75 md:hover:underline underline md:no-underline underline-offset-4"
                    >
                      B71 L8 Ph. 11-A Wellington Place, Gen. Trias, Cavite
                    </a>
                  </span>
                </p>

                <p className="flex items-start mb-4 -mx-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 sm:w-6 sm:h-6 mt-0 sm:mt-0.5 mx-2 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>

                  <span className="mx-2 font-semibold text-sm sm:text-lg tracking-wide text-gray-50 truncate w-auto">
                    <a
                      href="mailto:solarichenterprises@gmail.com"
                      className="transition-colors duration-300 transform hover:opacity-75 md:hover:underline underline md:no-underline underline-offset-4"
                    >
                      solarichenterprisescorp@gmail.com
                    </a>
                  </span>
                </p>

                <p className="flex items-start mb-4 -mx-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 sm:w-6 sm:h-6 mt-0 sm:mt-0.5 mx-2 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>

                  <span className="mx-2 font-semibold text-sm sm:text-lg tracking-wide text-gray-50 truncate w-72">
                    <a
                      href="tel:+639176213201"
                      className="transition-colors duration-300 transform hover:opacity-75 md:hover:underline underline md:no-underline underline-offset-4"
                    >
                      (+63) 917 621 3201
                    </a>
                  </span>
                </p>

                <p className="flex items-start mb-4 -mx-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 sm:w-6 sm:h-6 mt-0 sm:mt-0.5 mx-2 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>

                  <span className="mx-2 font-semibold text-sm sm:text-lg tracking-wide text-gray-50 truncate w-72">
                    <a
                      href="tel:+639855238627"
                      className="transition-colors duration-300 transform hover:opacity-75 md:hover:underline underline md:no-underline underline-offset-4"
                    >
                      (+63) 985 523 8627
                    </a>
                  </span>
                </p>

                <p className="flex items-start mb-4 -mx-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 sm:w-6 sm:h-6 mt-0 sm:mt-0.5 mx-2 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>

                  <span className="mx-2 font-semibold text-sm sm:text-lg tracking-wide text-gray-50 truncate w-72">
                    <a
                      href="tel:+639855238191"
                      className="transition-colors duration-300 transform hover:opacity-75 md:hover:underline underline md:no-underline underline-offset-4"
                    >
                      (+63) 985 523 8191
                    </a>
                  </span>
                </p>

                <p className="max-w-xl mb-4 mt-8 text-base text-gray-50 md:text-lg font-medium sm:texl-xl">
                  Follow us on social media.
                </p>

                <p className="flex items-start mb-4 -mx-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 sm:w-6 sm:h-6 mt-0 sm:mt-0.5 mx-2 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M7 10.2222V13.7778H9.66667V20H13.2222V13.7778H15.8889L16.7778 10.2222H13.2222V8.44444C13.2222 8.2087 13.3159 7.9826 13.4826 7.81591C13.6493 7.64921 13.8754 7.55556 14.1111 7.55556H16.7778V4H14.1111C12.9324 4 11.8019 4.46825 10.9684 5.30175C10.1349 6.13524 9.66667 7.2657 9.66667 8.44444V10.2222H7Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span className="mx-2 font-semibold text-sm sm:text-lg tracking-wide text-gray-50 truncate w-72">
                    <a
                      href="https://facebook.com/solarichecorp"
                      className="transition-colors duration-300 transform hover:opacity-75 md:hover:underline underline md:no-underline underline-offset-4"
                    >
                      facebook.com/solarichecorp
                    </a>
                  </span>
                </p>

                <p className="flex items-start mb-4 -mx-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 sm:w-6 sm:h-6 mt-0 sm:mt-0.5 mx-2 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M7 10.2222V13.7778H9.66667V20H13.2222V13.7778H15.8889L16.7778 10.2222H13.2222V8.44444C13.2222 8.2087 13.3159 7.9826 13.4826 7.81591C13.6493 7.64921 13.8754 7.55556 14.1111 7.55556H16.7778V4H14.1111C12.9324 4 11.8019 4.46825 10.9684 5.30175C10.1349 6.13524 9.66667 7.2657 9.66667 8.44444V10.2222H7Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span className="mx-2 font-semibold text-sm sm:text-lg tracking-wide text-gray-50 truncate w-72">
                    <a
                      href="https://facebook.com/solarichtraining"
                      className="transition-colors duration-300 transform hover:opacity-75 md:hover:underline underline md:no-underline underline-offset-4"
                    >
                      facebook.com/solarichtraining
                    </a>
                  </span>
                </p>

                <p className="flex items-start mb-4 -mx-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 sm:w-6 sm:h-6 mt-0 sm:mt-0.5 mx-2 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M11.9294 7.72275C9.65868 7.72275 7.82715 9.55428 7.82715 11.825C7.82715 14.0956 9.65868 15.9271 11.9294 15.9271C14.2 15.9271 16.0316 14.0956 16.0316 11.825C16.0316 9.55428 14.2 7.72275 11.9294 7.72275ZM11.9294 14.4919C10.462 14.4919 9.26239 13.2959 9.26239 11.825C9.26239 10.354 10.4584 9.15799 11.9294 9.15799C13.4003 9.15799 14.5963 10.354 14.5963 11.825C14.5963 13.2959 13.3967 14.4919 11.9294 14.4919ZM17.1562 7.55495C17.1562 8.08692 16.7277 8.51178 16.1994 8.51178C15.6674 8.51178 15.2425 8.08335 15.2425 7.55495C15.2425 7.02656 15.671 6.59813 16.1994 6.59813C16.7277 6.59813 17.1562 7.02656 17.1562 7.55495ZM19.8731 8.52606C19.8124 7.24434 19.5197 6.10901 18.5807 5.17361C17.6453 4.23821 16.51 3.94545 15.2282 3.88118C13.9073 3.80621 9.94787 3.80621 8.62689 3.88118C7.34874 3.94188 6.21341 4.23464 5.27444 5.17004C4.33547 6.10544 4.04628 7.24077 3.98201 8.52249C3.90704 9.84347 3.90704 13.8029 3.98201 15.1238C4.04271 16.4056 4.33547 17.5409 5.27444 18.4763C6.21341 19.4117 7.34517 19.7045 8.62689 19.7687C9.94787 19.8437 13.9073 19.8437 15.2282 19.7687C16.51 19.708 17.6453 19.4153 18.5807 18.4763C19.5161 17.5409 19.8089 16.4056 19.8731 15.1238C19.9481 13.8029 19.9481 9.84704 19.8731 8.52606ZM18.1665 16.5412C17.8881 17.241 17.349 17.7801 16.6456 18.0621C15.5924 18.4799 13.0932 18.3835 11.9294 18.3835C10.7655 18.3835 8.26272 18.4763 7.21307 18.0621C6.51331 17.7837 5.9742 17.2446 5.69215 16.5412C5.27444 15.488 5.37083 12.9888 5.37083 11.825C5.37083 10.6611 5.27801 8.15832 5.69215 7.10867C5.97063 6.40891 6.50974 5.8698 7.21307 5.58775C8.26629 5.17004 10.7655 5.26643 11.9294 5.26643C13.0932 5.26643 15.596 5.17361 16.6456 5.58775C17.3454 5.86623 17.8845 6.40534 18.1665 7.10867C18.5843 8.16189 18.4879 10.6611 18.4879 11.825C18.4879 12.9888 18.5843 15.4916 18.1665 16.5412Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span className="mx-2 font-semibold text-sm sm:text-lg tracking-wide text-gray-50 truncate w-72">
                    <a
                      href="https://www.instagram.com/solarich.ecorp/"
                      className="transition-colors duration-300 transform hover:opacity-75 md:hover:underline underline md:no-underline underline-offset-4"
                    >
                      instagram.com/solarich.ecorp
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default ContactSection;
